import React, { useState, useEffect } from 'react';
import { Add } from '@mui/icons-material';
import { Cancel } from '@material-ui/icons';

import 'assets/scss/tags_select.scss';
import BeSafeButton from 'components/commons/BeSafeButton';
import BeSafeMultiSelectModal from 'components/commons/multiselect/BeSafeMultiSelectModal';
import BeSafeMultiSelectTableModal from 'components/commons/multiselect/BeSafeMultiSelectTableModal';
import { useIntl } from 'react-intl';
import BeSafeContainer from '../BeSafeContainer';

const BeSafeMultiSelect = (props) => {
  const [selectedItems, setSelectedItems] = useState(props.selectedItems || []);
  const [showModal, setShowModal] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    setSelectedItems(props.selectedItems || []);
  }, [props.selectedItems]);

  const removeItems = (indexToRemove) => {
    setSelectedItems([
      ...selectedItems.filter((_, index) => index !== indexToRemove),
    ]);

    props.onChange([
      ...selectedItems.filter((_, index) => index !== indexToRemove),
    ]);
  };

  const onItemChange = (items) => {
    setSelectedItems(items);

    props.onChange(items);
  };

  const handleTab = (e) => {
    const textValue = e.target.value;
    if (textValue === '' && props.validateEmpty) props.validate(textValue);
    if (textValue === '') return;
    if (props.limit > 0 && selectedItems.length >= props.limit) return;

    if (props.validate(textValue)) {
      onItemChange([...selectedItems, textValue]);

      e.target.value = '';
    }
  };

  const getTitle = () => {
    if (props.profileType === 'firewall') {
      return intl.formatMessage(
        { id: 'DEVICES.FIREWALL_PROFILE.MODAL_TITLE' },
        { name: props.profileName }
      );
    }

    return intl.formatMessage(
      { id: 'DEVICES.PROFILES.MODAL_TITLE' },
      { name: props.profileName }
    );
  };

  const getInputClassName = () => {
    if (props.inputClassName) return ' ' + props.inputClassName;
    return '';
  };

  return (
    <>
      <div
        className={`position-relative ${
          !props.applyClass ? 'd-flex' : props.applyClass
        }`}
      >
        <div className="tags-select">
          {props.limitVisible && selectedItems.length > 5 ? (
            <>
              <ul id="tags">
                {selectedItems.slice(0, 5).map((item, index) => (
                  <li key={index} className="tag">
                    <span className="ellipsable">{props.formatName(item)}</span>
                    <BeSafeContainer visible={!props.disabled}>
                      <Cancel
                        className="ml-1 tag-button"
                        onClick={() => removeItems(index)}
                      />
                    </BeSafeContainer>
                  </li>
                ))}
              </ul>
              ...
            </>
          ) : (
            <ul id="tags">
              {selectedItems.map((item, index) => (
                <li key={index} className="tag">
                  <span className="ellipsable">{props.formatName(item)}</span>
                  <BeSafeContainer visible={!props.disabled}>
                    <Cancel
                      className="ml-1 tag-button"
                      onClick={() => removeItems(index)}
                    />
                  </BeSafeContainer>
                </li>
              ))}
            </ul>
          )}

          <input
            type="text"
            className={'border-secondary form-control' + getInputClassName()}
            placeholder={props.placeholder}
            disabled={!props.inputEnabled}
            onBlur={(e) => {
              handleTab(e);
            }}
            onKeyDown={(e) => {
              if (e.key.match(/^(Tab|Enter)$/)) {
                e.preventDefault();
                handleTab(e);
              }
            }}
          />
        </div>
        {!props.disableModal && (
          <BeSafeButton
            className="btn-primary-transparent btn-in-box"
            onClick={() => {
              setShowModal(true);
            }}
            icon={<Add />}
            variant="transparent"
          />
        )}
      </div>

      <BeSafeContainer visible={!props.disableModal && props.modalName === ''}>
        <BeSafeMultiSelectModal
          showModal={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          onChange={onItemChange}
          initialSelected={selectedItems}
          items={props.items}
          limit={props.limit}
          title={props.multiSelectTitle}
        />
      </BeSafeContainer>

      <BeSafeContainer
        visible={
          !props.disableModal && props.modalName === 'deviceFirewallProfile'
        }
      >
        <BeSafeMultiSelectTableModal
          modalTitle={getTitle()}
          showModal={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          onChange={onItemChange}
          initialSelected={selectedItems}
          items={props.items}
          limit={props.limit}
          columns={props.columns}
        />
      </BeSafeContainer>
    </>
  );
};

BeSafeMultiSelect.defaultProps = {
  columns: [],
  onChange: () => {},
  limit: 0,
  modalName: '',
  validate: () => true,
  limitVisible: true,
  validateEmpty: false,
};

export default BeSafeMultiSelect;
